import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo, MensajeCapcha } from '../../mensajes2';
import { Dimmer } from '../../spinner';

import 'react-tabs/style/react-tabs.css';
import axios from 'axios';


export const Motivo = (props) => {

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [visible, setVisible] = useState(false);
    const [msg2, setMsg2] = useState();
    const [activate, setActivate] = useState(false);
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const txtDescrp = useRef();
    const txtStatus = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtID = useRef();
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [habilitadoNR, setHabilitadoNR] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const [values, setValues] = useState({
        idcomercio: '',
        statuspublicidad: '',
        motivopublicidad: ''
    });

    let token = localStorage.getItem('jwtToken');
    let op = require('../../../../src/modulos/datos');

    const onChange = (event) => {

        if (event.target.name === 'motivopublicidad') {
            event.target.value = event.target.value.toUpperCase();
        }

    };


    const Actualizar = (idcomercio) => {

        let endpoint = `${op.conexion}/api/publicidad/actmotivo/${idcomercio}`;
        let body;
        setActivate(true);
        console.log(idcomercio);

        body = {
            idcomercio: parseInt(txtID.current.value),
            statuspublicidad: parseInt(txtStatus.current.value === '1' ? '0' : '1'),
            motivopublicidad: txtDescrp.current.value.trim(),
        };

        console.log(body);

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                if (props.comercio.idcomercio > 0) {
                    console.log(response.data);


                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Motivo Registrado Correctamente', icono: 'error' });


                } else {
                    console.log(response.data);

                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Error al Registrar el Motivo', icono: 'error' });



                }

            }
            setActivate(false);
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });

            setActivate(false);

        })

    }

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtDescrp.current.value.trim() === '') {

            setMensaje({ mostrar: true, titulo: 'ERROR', texto: 'Debe Introducir la Descripción del Motivo', icono: 'error' });

            sigue = false;
            txtDescrp.current.focus();

        } else if (sigue === true) {

            Actualizar(props.comercio.idcomercio);
        }
    }

    const blanquear = () => {

        setVisible(false);
        setMostrar1(false);
        setActivate(false);
        setValues({
            idcomercio: '',
            statuspublicidad: '',
            motivopublicidad: ''
        });
        setTabIndex(0);
        setOperacion(0);
        setMsg('');

    }

    const handleCloseSi = () => {
        setMostrar1(false);
    };

    const handleCloseNo = () => {
        setMostrar1(false);
    };

    const cerrarModal = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        if (mensaje.texto == 'Motivo Registrado Correctamente' || mensaje.texto == 'Error al Registrar el Motivo') {
            blanquear();
            props.onHideRenderizarp();
            props.onHideCancela();

        }
    }

    const handleCloseMensa = (e) => {
        e.preventDefault();
        setMostrar(false);
        if (msg == 'Motivo Registrado Correctamente' || msg == 'Error al Registrar el Motivo') {
            blanquear();
            props.onHideRenderizarp();
            props.onHideCancela();

        }

    }

    const cancelar = (e) => {
        e.preventDefault();
        setHabilitadoNR(false);
        blanquear();
        props.onHideCancela();

    }


    return (
        <Modal
            {...props}
            size="xs"
            style={{ backgroundColor: "rgb(0,0,0,0.3)" }}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setVisible(false);
                btnAcepta.current.focus();
                setOperacion(props.operacion);
                setTabIndex(0);
                if (props.operacion !== 1) {
                    setValues(props.comercio);
                    console.log(props.comercio);
                }

            }}

        >
            <Modal.Header className='azulty' style={{ height: "40px" }}>
                <div style={{ color: "#fff", fontFamily: 'Times New Roman, Times, serif', fontSize: 20 }}>{props.operacion === 1 ? 'Agregar Motivo.' : props.operacion === 2 ? 'Editar Motivo.' : props.operacion === 3 ? 'Eliminar Motivo.' : 'Motivo.'}</div>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#fff", color: "" }}>
                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div>

                    <div className="card" style={{ fontFamily: 'Times New Roman, Times, serif', fontSize: '15px' }}>
                        <h5 class="card-header" style={{ fontWeight: 'bold' }}>Motivo del Cambio de Estatus</h5>
                        <div className='card-body'>
                            <div className="input-group-sm col-md-12">
                                <textarea type="text" disabled={operacion === 4 || operacion === 3 ? true : deshabilitado} ref={txtDescrp} name='motivopublicidad' className="form-control text-uppercase" onChange={onChange} defaultValue={values && values.motivopublicidad === null ? values.motivopublicidad : ''} id="inputDescripcion" />
                            </div>
                        </div>
                        <input type="hidden" ref={txtID} name='idcomercio' value={values && values.idcomercio} />
                        <input type="hidden" ref={txtStatus} name='statuspublicidad' value={values && values.statuspublicidad} />
                    </div>

                </div>


            </Modal.Body >
            <Modal.Footer style={{ backgroundColor: "" }}>
                <button ref={btnAcepta} disabled={operacion === 4 ? true : false} onClick={onChangeValidar} className="btn btn-success col-md-3"><i className="fas fa-check-circle">  Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-secondary col-md-3"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal >
    );
}